import { render } from "./HomeTimeView.vue?vue&type=template&id=8c04e3e6"
import script from "./HomeTimeView.vue?vue&type=script&lang=js"
export * from "./HomeTimeView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__